module.exports = "/_next/static/images/9b2f7427ebc02f99831ae26432038f9f-wow@2x.png";